




























import { Component, Prop, Vue } from "@/shared/node_modules/vue-property-decorator";

// The course syllabus as the guideline sessions: modules with their lessons in order, done, current or locked.
@Component
export default class CourseLessons extends Vue {
  @Prop({ type: Array, required: true }) sections!: any[];
  @Prop({ type: Array, default: () => [] }) progress!: any[];
  @Prop({ type: Boolean, default: false }) sequential!: boolean;
  @Prop({ type: Boolean, default: true }) enabled!: boolean;
  @Prop({ type: Number, default: 0 }) currentId!: number;
  @Prop({ type: String, default: "" }) currentLabel!: string;

  get lessons(): any[] {
    return this.sections.flatMap((s: any) => s.lessons);
  }

  isDone(lesson: any): boolean {
    const p = this.progress.find((x: any) => x.courseLessonId === lesson.id);
    return !!p && p.status === 2;
  }

  isLocked(lesson: any): boolean {
    if (!this.sequential) return false;
    const idx = this.lessons.findIndex((l: any) => l.id === lesson.id);
    return idx > 0 && !this.isDone(this.lessons[idx - 1]);
  }

  number(lesson: any): number {
    return this.lessons.findIndex((l: any) => l.id === lesson.id) + 1;
  }

  time(s: number): string {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }
}
